export default __webpack_public_path__ + "static/media/moon.ee887de5.jpg";